import PropTypes from "prop-types"
import React from "react"
import { compose, withProps } from "recompose"
import { Table } from "semantic-ui-react"

const { Body, Cell, Header, HeaderCell, Row } = Table

const RegistryTable = ({ headers, rows }) => (
	<Table celled>
		<Header>
			<Row>
				{headers.map((header, index) => (
					<HeaderCell key={index}>{header}</HeaderCell>
				))}
			</Row>
		</Header>
		<Body>
			{rows.map((cells = [], rowIndex) => (
				<Row key={rowIndex}>
					{cells.map((cell, cellIndex) => (
						<Cell key={cellIndex}>
							<div dangerouslySetInnerHTML={{ __html: cell }} />
						</Cell>
					))}
				</Row>
			))}
		</Body>
	</Table>
)

RegistryTable.propTypes = {
	headers: PropTypes.array,
	rows: PropTypes.array
}

RegistryTable.defaultProps = {
	headers: [],
	rows: []
}

const enhance = compose(
	withProps(({ columns = [], rows = [] }) => ({
		headers: columns.map(({ name }) => name),
		rows: rows.map(row => columns.map(({ id }) => row[id]))
	}))
)

export default enhance(RegistryTable)



// WEBPACK FOOTER //
// ./src/containers/registry/components/RegistryTable.js